import HttpGlobal from "../Global/HttpGlobal.class";
import { customerApiBaseUrl, isNativeMode } from "../../../native/nativeMode";

export default class HttpSignatureRepository extends HttpGlobal {
  private readonly API_URL_SIGNATURE:
    | string
    | undefined = `${process.env.REACT_APP_CUSTOMER_APP_URL}api/v2/signature`;

  /**
   * Firma del alta NATIVE (P1b): un born-native firma su contrato a través del
   * gateway native, no del monolito. Una sola ruta idempotente
   * (`/customer/leads/{lead}/contract-signature`) genera el contrato AGL en
   * documentator, crea el sobre y devuelve la `signUrl` de Viafirma. La oferta
   * ya está congelada (selection-lock al pagar), así que la firma es estable.
   */
  private nativeContractSignature = async () =>
    this.generalPost({
      url: `${customerApiBaseUrl()}/customer/leads/${this.leadId}/contract-signature`,
      dataRequest: {},
    });

  getSignStatus = async () => {
    // Born-native: el estado de firma sale del gateway (máquina de estado del
    // alta → "SIGNED"/"PENDING"), no del endpoint de firma del monolito.
    const url = isNativeMode()
      ? `${customerApiBaseUrl()}/customer/leads/${this.leadId}/contract-status`
      : `${this.API_URL_SIGNATURE}/contract/status/${this.leadId}`;
    const response = await this.generalGet(url);
    return response;
  };

  postCreateContract = async () => {
    if (isNativeMode()) {
      // El contrato se genera + el sobre se crea en la misma llamada idempotente;
      // la URL la recoge getSignatureEmbedded.
      return this.nativeContractSignature();
    }
    const response = await this.generalPost({
      url: `${this.API_URL_SIGNATURE}/contract/create-contract/${this.leadId}`,
      dataRequest: {},
    });

    return response;
  };

  getSignatureEmbedded = async () => {
    if (isNativeMode()) {
      // Idempotente (misma oferta congelada → mismo sobre): devuelve la signUrl
      // con la forma que el controller espera (`response.url`).
      const response: any = await this.nativeContractSignature();
      return { url: response?.signUrl };
    }
    const response = await this.generalGet(
      `${this.API_URL_SIGNATURE}/contract/ready-to-embedded/${this.leadId}`
    );
    return response;
  };
}
